export const PING_READ_ONLY_HTTP_HEADER = "ping-read-only-token";

export const getHttpHeaders = (accessToken: string, readOnlyToken: string) => {
  const urlObj = new URL(window.location.href);
  const readOnlyTokenOverride = urlObj.searchParams.get("token");

  const authorization = accessToken
    ? `Bearer ${accessToken}`
    : readOnlyToken
      ? `ExcelJWT ${readOnlyToken}`
      : undefined;

  return {
    ...(readOnlyTokenOverride
      ? { [PING_READ_ONLY_HTTP_HEADER]: readOnlyTokenOverride }
      : {}),
    ...(authorization ? { Authorization: authorization } : {}),
  };
};
